import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthStore } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthStore);
  const token = auth.token();

  if (token && !req.url.includes('/auth/login')) {
    const cloned = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(cloned).pipe(
      tap({
        error: (err) => {
          if (err.status === 401) {
            console.warn('[Auth] Token expired or invalid — logging out');
            auth.logout();
          }
        },
      }),
    );
  }

  return next(req);
};
